import axios from "../config/axios-chatbot";

export const ContactNumberRepository = {
  getAll: (flow) => {
    return axios.get(`/api/contact-number`, {params: {flow}});
  },
  get: (id) => {
    return axios.get(`/api/contact-number/${id}`);
  },
  createOrUpdate: (data) => {
    return axios.post(`/api/contact-number`, data);
  },
  createOrUpdateByConversation: (conversationId, senderName) => {
    return axios.post(`/api/contact-number/by-conversation/${conversationId}`, {senderName});
  },
  update: (id, data) => {
    return axios.put(`/api/contact-number/${id}`, data);
  },
  delete: (id) => {
    return axios.delete(`/api/contact-number/${id}`);
  },
}
